export default __webpack_public_path__ + "static/media/A4PosterLeft.bf23d716.png";